import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import clsx from "clsx";
import { themeTypeToBool } from '../../../utils/helpers';
import { TooltipRight } from "../../Common/CustomTooltips";
import sedanLight from "../../../images/carAvatar/sedanLight.svg";
import suvLight from "../../../images/carAvatar/suvLight.svg";
import hatchbackLight from "../../../images/carAvatar/hatchbackLight.svg";
import vanLight from "../../../images/carAvatar/vanLight.svg";
import combiLight from "../../../images/carAvatar/combiLight.svg";
import sedanDark from "../../../images/carAvatar/sedanDark.svg";
import suvDark from "../../../images/carAvatar/suvDark.svg";
import hatchbackDark from "../../../images/carAvatar/hatchbackDark.svg";
import vanDark from "../../../images/carAvatar/vanDark.svg";
import combiDark from "../../../images/carAvatar/combiDark.svg";
import motorbikeLight from "../../../images/carAvatar/motorAvatarLight.png";
import motorbikeDark from "../../../images/carAvatar/motorAvatarDark.png";
import sportLight from "../../../images/carAvatar/sportLight.svg";
import sportDark from "../../../images/carAvatar/sportDark.svg";

const useStyles = makeStyles(() => ({
    shape: {
        width: 62,
        height: 62,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    shapeCircle: {
        borderRadius: '50%',
        border: "1px solid #A5A4BF"
    },
    carIcon: {
        width: "100%",
        margin: "auto",
        color: "#757490"
    },
    carImg: {
        width: 55,
        height: 40,
    }
}));

const evaluateType = (type, theme) => {
    switch(type) {
        case "Sedan":
            return themeTypeToBool(theme.palette.type) ? sedanLight : sedanDark;
        case "Hatchback":
            return themeTypeToBool(theme.palette.type) ? hatchbackLight : hatchbackDark;
        case "SUV":
            return themeTypeToBool(theme.palette.type) ? suvLight : suvDark;
        case "Combi":
            return themeTypeToBool(theme.palette.type) ? combiLight : combiDark;
        case "Van":
            return themeTypeToBool(theme.palette.type) ? vanLight : vanDark;
        case "Motocykl":
            return themeTypeToBool(theme.palette.type) ? motorbikeLight : motorbikeDark;
        case "Sportowy":
            return themeTypeToBool(theme.palette.type) ? sportLight : sportDark;
        default:
            return themeTypeToBool(theme.palette.type) ? sedanLight : sedanDark;
    }
};

function CarAvatar(props) {
    const theme = useTheme();
    const classes = useStyles(theme);
    const { selected, type = "sedan" } = props;

    return (
        <TooltipRight title={type}>
            <div
                className={clsx(classes.shape, classes.shapeCircle)}
                style={{ borderColor: selected ? (themeTypeToBool(theme.palette.type) ? "inherit" : "#FFF") : "inherit" }}
            >
                {type ?
                    <img src={evaluateType(type, theme)} alt="avatar" className={classes.carImg}/>
                    :
                    <DriveEtaIcon className={classes.carIcon} />
                }
            </div>
        </TooltipRight>
    );
}

export default CarAvatar;

CarAvatar.propTypes = {
    selected: PropTypes.bool,
    type: PropTypes.string
};

